import { socketIOClient } from "./socket-io-client";

/**
 * Client-side counterpart to app/_lib/realtime (server-side). Every existing
 * `pusherClient.subscribe(channel).bind(event, cb)` / `.unsubscribe(channel)`
 * call site imports `realtimeClient` from here — the shape is identical to
 * pusher-js's Channel API, so no call sites needed changes.
 */
export const realtimeClient = socketIOClient;
